import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container } from "reactstrap";
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Badge,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
  } from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


import axios from 'axios';
import * as url from "../../helpers/url_helper"
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import { PENDING_LEAVE_REQUESTS, LEAVE_REQUESTS, COST_CENTERS, POSTED_LR, APPNAME } from '../../helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'


    const MyApplications = () => {
      const history = useHistory();

      toastr.options = TOAST_OPTIONS;

      const [isLoading, setIsLoading] = useState(false)
      const [applicants, setApplicants] = useState([]);
      const [username, setusername] = useState('')
      const [applicantNo, setApplicantNo] = useState('')
      const [firstName, setFirstName] = useState('')
        const [lastName, setLastName] = useState('')
        const [middleName, setMiddleName] = useState('')
        const [gender, setGender] = useState('')
        const [email, setEmail] = useState('')
        const [phone, setPhone] = useState('')
        const [country, setCountry] = useState('')
        const [dateofbirth, setDateofBirth] = useState('')
        const [countryResidence, setCountryResidence] = useState('')
        const [address, setAddress] = useState('')
        const [hearaboutus, setHearAboutUs] = useState('')
        const [maritalstatus, setMaritalStatus] = useState('')
        const [nationalID, setNationalID] = useState('')
         
        useEffect(() => {
            let obj = JSON.parse(localStorage.getItem("authApplicant"))
            let Applicantemail = obj.email;
            axios.get(url.APPLICANTS+"?$filter=EMail eq '"+Applicantemail+"'", HRConfig).then((r)=>{
                setusername(`${obj.fname} ${obj.lname}`)
                setFirstName(`${obj.fname}`)
                setLastName(`${obj.lname}`)
                setMiddleName(`${obj.mname}`)
                setGender(`${obj.gender}`)
                setPhone(`${obj.phone}`)
                setEmail(`${obj.email}`)
                setDateofBirth(`${obj.dateofbirth}`)
                setCountry(`${obj.country}`)
                setApplicants(r.data.value)
                setIsLoading(false)
        }).catch((e)=>{
            setIsLoading(false)
            console.log(e)
          })
      }, []);

      
      const { SearchBar } = Search;
      const columns = [
      {
        dataField: 'No',
        text: 'Recruitment Project Number',
        sort: true,
        formatter: noFormatter
      },
      {
        dataField: 'Employee_No',
        text: 'Applicant Number',
        sort: true
      }, 
      {
        dataField: 'Employee_Name',
        text: 'Name',
        sort: true
      }, 

      {
        dataField: 'Posting_Date',
        text: 'Posting Date',
        sort: true
      },
      {
        dataField: 'Annual_Leave_WS',
        text: 'Type',
        sort: true,
        formatter: typeFormatter
      },
      {
        dataField: 'No_of_Days',
        text: 'Days',
        sort: true
      }, 
      {
        dataField: 'Status',
        text: 'Status',
        sort: true,
        formatter: statusFormatter
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "",
        formatter: actionFormatter
      }];

      const defaultSorted = [{
        dataField: 'No',
        order: 'desc'
      }];

      function noFormatter(cellContent, row){
        return(
          <strong>{cellContent}</strong>
        )
      }
      function typeFormatter(cellContent, row){
        if(row.Annual_Leave_WS == 'Yes'){
          return(
            <strong>ANNUAL</strong>
          )
        }else if(row.Sick_Leave_WS == 'Yes'){
          return(
            <strong>SICK</strong>
          )
        }else if(row.Maternity_Leave_WS == 'Yes'){
          return(
            <strong>MATERNITY</strong>
          )
        }else if(row.Paternity_Leave_WS == 'Yes'){
          return(
            <strong>PATERNITY</strong>
          )
        }else if(row.Compassionate_Leave_WS == 'Yes'){
          return(
            <strong>COMPASSIONATE</strong>
          )
        }else if(row.Study_Leave_WS == 'Yes'){
          return(
            <strong>STUDY</strong>
          )
        }else{
          return(
            <strong>UNPAID</strong>
          )
        }
      }
      function actionFormatter(cellContent, row){
        return(
          <Button
            type="button"
            color="info"
            className="btn-sm btn-rounded"
            onClick={()=>{ history.push(`/leave-request-details/${row.SystemId}`); }}
          >
            Details
          </Button>
        )
      }
      function statusFormatter(cellContent, row) {
        if (row.Status == "Pending Approval") {
          return (
            <div>
                <Badge className="me-2 bg-warning">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.Status == "Approved"){
          return (
            <div>
                <Badge className="me-2 bg-success">
                { cellContent }
                </Badge>
            </div>
          );
        }else{
          return (
            <div>
                <Badge className="me-2 bg-danger">
                { cellContent }
                </Badge>
            </div>
          );
        }
      }

        return (
            <>
            <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>My Applications | {APPNAME}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={APPNAME} breadcrumbItem="My Applications" />
                    <Row>
          

            <Col lg={12}>
              <Card>
                <CardBody>
                   {applicants && (applicants.length > 0) && (
                    <ToolkitProvider
                      keyField="No"
                      data={ applicants }
                      columns={ columns }
                      search
                    >
                      { toolkitProps => (
                          <React.Fragment>
                            <Row className='mb-5'>
                              <Col lg={8}>
                                  <div  className="rounded bg-light d-grid gap-2">
                                    <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                  </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                
                            
                                <BootstrapTable 
                                  keyField='No' 
                                  data={ applicants } 
                                  columns={ columns } 
                                  striped
                                  hover
                                  condensed
                                  bordered={ false }
                                  noDataIndication="No Records" 
                                  defaultSorted={ defaultSorted }
                                  classes={ "table-sm align-middle table-check" }
                                    {...toolkitProps.baseProps}
                                  />
                             
                             </Col>
                             </Row>
                             </React.Fragment>
                            
                      )
                    }
                  </ToolkitProvider>
                  )}
                  {applicants && (applicants.length < 1) && (
                    <div className="text-center">
                      <div className="mb-4">
                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                      </div>
                      <div>
                      <h5>No Applications Found</h5>
                      <p className="text-muted">
                              
                      </p>
                      </div>
                  </div>

                  )}
                </CardBody>
              </Card>
            </Col>

            

          </Row>

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default MyApplications;